import React from "react";
import { tutorRows } from "../data";
import SectionHead from "./SectionHead";

const rowClasses = ["marquee-row", "marquee-row reverse", "marquee-row slow"];

const TutorMarquee = () => (
  <section className="tutors-section" aria-labelledby="tutors-heading">
    <div className="container">
      <SectionHead
        headingId="tutors-heading"
        title={
          <>
            Want a <em>thought leader</em> instead?
          </>
        }
      />
      <div className="tutors-intro">
        We can also arrange{" "}
        <strong>keynote talks, masterclasses and copywriting deep-dives</strong>{" "}
        with selected tutors from our 60-strong course faculty. Same enquiry
        form, same warm welcome. Here are some of the people we work with.
      </div>
    </div>
    <div
      className="marquee-container"
      role="region"
      aria-roledescription="auto-scrolling marquee"
      aria-label="Selected tutors who teach on 42courses"
    >
      {tutorRows.map((row, index) => {
        const tutors = [...row, ...row];
        return (
          <div
            className={rowClasses[index]}
            key={row.map((tutor) => tutor.name).join("-")}
            aria-hidden="true"
          >
            {tutors.map((tutor, tutorIndex) => (
              <div className="tutor-chip" key={`${tutor.name}-${tutorIndex}`}>
                <span className="tutor-name">{tutor.name}</span>
                <span className="tutor-title">{tutor.title}</span>
              </div>
            ))}
          </div>
        );
      })}
    </div>
    <div className="container">
      <div className="tutors-cta">
        Like the look of someone? <a href="#enquire">Tell us in the form</a> and
        we'll see what we can do.
      </div>
    </div>
  </section>
);

export default TutorMarquee;
